import { render, staticRenderFns } from "./formItemEditor.vue?vue&type=template&id=6118b232&"
import script from "./formItemEditor.vue?vue&type=script&lang=js&"
export * from "./formItemEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports